import React from "react";
import { NavLink } from "react-router-dom";
import { KIcon } from "@kyburz/kdesign-system";
import "./NavItem.css";

const NavItem = ({ name, icon, route }) => {
  return (
    <NavLink to={route} className="navitem__link">
      <li className="navitem__item">
        <span className="navitem__icon">
          <KIcon icon={icon} size={20} color="#9BA2B3" strokeWidth={2} />
        </span>
        <p className="navitem__text">{name}</p>
      </li>
    </NavLink>
  );
};

export default NavItem;
